import { useEffect, useState } from "react";

import styled from "styled-components/macro";

import {
  SectionContent,
  WrapperVerticalPadding,
  sidePadding,
} from "Payments/PaymentPage/PaymentFormScreen/styles";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import classNames from "classnames";
import { AnimatePresence, motion } from "framer-motion";

import { usePaymentForm } from "../PaymentFormContext";

import ChooseMethodType from "./ChooseMethodType";
import NewPaymentMethod from "./NewPaymentMethod";
import PaymentMethodIcon from "./PaymentMethodIcon";
import SelectedPaymentMethod from "./SelectedPaymentMethod";
import Untouched from "./Untouched";

export default function PaymentMethodSection() {
  const {
    state: { formStages, isSubmitting },
    dispatch: formDispatch,
  } = usePaymentForm();
  const {
    state: { network },
    dispatch,
  } = usePaymentPage();

  const isSkippedAuth = formStages?.auth === "skipped";
  const [isHovering, setIsHovering] = useState(false);
  const isClickable =
    formStages.paymentInfo === "methodSelected" &&
    formStages.auth !== "skipped";

  const handlePaymentMethodClick = () => {
    if (isSubmitting) return;

    if (isSkippedAuth) {
      formDispatch({
        type: "setFormStage",
        stage: "paymentInfo",
        value: network.isACHAllowed ? "chooseAddMethodType" : "addCard",
      });
      dispatch({ type: "setSelectedPaymentMethodID", payload: null });
      dispatch({ type: "setPaymentMethods", payload: [] });
    } else {
      dispatch({
        type: "setScreenControlFlag",
        flag: "isManagingPaymentMethods",
        value: true,
      });
    }

    dispatch({ type: "setEditingRecurringPayment", payload: false });
  };

  const hoverStart = () => {
    if (!isSubmitting) setIsHovering(true);
  };
  const hoverEnd = () => setIsHovering(false);

  useEffect(() => {
    if (isSubmitting) hoverEnd();
  }, [isSubmitting]);

  const renderContent = () => {
    switch (formStages.paymentInfo) {
      case "chooseAddMethodType":
        return <ChooseMethodType key="choose_method_type" />;
      case "addCard":
        return <NewPaymentMethod key="new_payment_method" />;
      case "methodSelected":
        return (
          <SelectedPaymentMethod
            isHovering={isHovering}
            isSkippedAuth={isSkippedAuth}
            key="selected_payment_method"
            handlePaymentMethodClick={handlePaymentMethodClick}
          />
        );
      default:
        return <Untouched key="untouched" />;
    }
  };

  return (
    <Wrapper>
      <PaymentMethodSectionContent>
        <ClickWrapper
          onHoverStart={isClickable ? hoverStart : null}
          onHoverEnd={isClickable ? hoverEnd : null}
          whileTap={isClickable && !isSubmitting && { scale: 0.96 }}
          onClick={isClickable ? handlePaymentMethodClick : null}
          className={classNames({
            willNavigateToPaymentMethods: !isSubmitting && isClickable,
          })}
        >
          <PaymentMethodIcon />
          <Contents>
            <AnimatePresence>{renderContent()}</AnimatePresence>
          </Contents>
        </ClickWrapper>
      </PaymentMethodSectionContent>
      <WrapperVerticalPadding />
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  ${sidePadding}
`;

const PaymentMethodSectionContent = styled(SectionContent)`
  padding: 0;
  overflow: visible;
`;

const ClickWrapper = styled(motion.div)`
  display: flex;
  align-items: center;
  flex-grow: 1;
  padding: 14px;
  &.willNavigateToPaymentMethods {
    cursor: pointer;
  }
`;

const Contents = styled.div`
  flex-grow: 1;
`;
